import { Menu, MenuProps } from 'antd';

export const AntMenu = Menu;
export const AntMenuItem = Menu.Item;
export const AntSubMenu = Menu.SubMenu;
export type AntMenuProps = MenuProps;
